import React, { useState, useEffect, useRef } from 'react';
import './../App.css';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';
import ApiService from '../services/ApiService';
import AnimeCardComponent from '../components/animecard/AnimeCardComponent';
import { useParams } from 'react-router-dom';

const CollectionPage = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCollection, setSelectedCollection] = useState(null);
    const [collections, setCollections] = useState([]);
    const [animeIds, setAnimeIds] = useState([]);
    const [page, setPage] = useState(0); // Track current page for infinite scrolling
    const thatsAll = useRef(false); // Ref to track if there's no more data to load
    const initialized = useRef(false);
    const currentLoadingPage = useRef(-1); // Track current loading page
    const fetchedCollections = useRef(false); // Ensure collections fetch is not repeated
    const { id } = useParams();

    let lastPage = -1;
    useEffect(() => {
        const fetchData = async () => {
            if (!fetchedCollections.current) {
                fetchedCollections.current = true;
                const catData = await ApiService.getCollections(id);
                if (catData.type === "success") {
                    setCollections(catData.data);
                    const initialCollection = catData.data[0];
                    setSelectedCollection(initialCollection);
                    const uniqueAnimeIds = Array.from(new Set(initialCollection.animeIds));
                    setAnimeIds(uniqueAnimeIds);

                    thatsAll.current = false; // Reset "thatsAll" status
                }
            }
        };

        fetchData();
    }, [id]);

    const fetchAnimeByPage = async (pageIndex) => {

        const start = pageIndex * 10;
        const idsToFetch = animeIds.slice(start, start + 10);
        if (idsToFetch.length === 0) {
            thatsAll.current = true;
            return;
        }
        if (lastPage == pageIndex) return;
        setLoading(true);
        lastPage = pageIndex;
        const data = await ApiService.getAnimeByIds(idsToFetch);
        if (data.type === "success") {

            setAnimeList((prevAnimeList) => [...prevAnimeList, ...data.data]); // Append new anime data
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;

            if (scrollTop + clientHeight >= scrollHeight - 50 && !loading && !thatsAll.current) {
                setPage((prevPage) => prevPage + 1);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll); // Cleanup listener
    }, [loading, animeIds]);
    useEffect(() => {
        if (page !== currentLoadingPage.current && animeIds.length > 0) {
            currentLoadingPage.current = page;
            fetchAnimeByPage(page);
        }
    }, [page, animeIds]);

    useEffect(() => {
        if (!initialized.current) {
            fetchAnimeByPage(page); // Only call this on the first initialization of a collection
            initialized.current = true; // Ensure it won't be called again when the collection changes
        }
    }, [selectedCollection]);


    const handleCollectionChange = (collection) => {
        if (collection === selectedCollection) return;

        setSelectedCollection(collection);
        const uniqueAnimeIds = Array.from(new Set(collection.animeIds));
        setAnimeIds(uniqueAnimeIds);
        lastPage = -1;
        // Reset the state for the new collection
        setAnimeList([]);
        setPage(0);
        currentLoadingPage.current = -1; // Ensure no conflict with page change
        thatsAll.current = false; // Reset all data

        initialized.current = false; // Allow initial fetch for the new collection
    };
    return (
        <PageShell
            sidebar
           
            className="catalog-page collection-page"
        >
            <PageHeader title="Коллекции">
                {collections.length > 0 ? (
                    <div className="ui-chips collection-selectors" role="tablist">
                        {collections.map((collection) => (
                            <button
                                type="button"
                                role="tab"
                                key={collection.id}
                                aria-selected={selectedCollection === collection}
                                className="ui-chip"
                                onClick={() => handleCollectionChange(collection)}
                            >
                                {collection.name}
                            </button>
                        ))}
                    </div>
                ) : null}
            </PageHeader>

            {animeList.length > 0 ? (
                <div className="anime-container">
                    {animeList.map((anime, index) => (
                        <AnimeCardComponent key={index} anime={anime} isInteractive={true} />
                    ))}
                </div>
            ) : !loading ? (
                <div className="ui-empty">
                    <h2 className="ui-empty__title">Здесь пока пусто</h2>
                    <p className="ui-empty__text">В этой коллекции ещё нет аниме.</p>
                </div>
            ) : null}

            {loading && !thatsAll.current && <p className="ui-status">Загружаем больше…</p>}
        </PageShell>
    );
};

export default CollectionPage;
